import { Pedestrismo, PedestrismoBackup } from '../constants/enums';

export function parseTimerInput(value) {
  const match = String(value).trim().match(/^(\d{1,3}):([0-5]\d):([0-5]\d)(?:\.(\d{1,3}))?$/);
  if (!match) return null;
  return (Number(match[1]) * 3600 + Number(match[2]) * 60 + Number(match[3])) * 1000
    + Number(((match[4] || '') + '000').slice(0, 3));
}

export function adjustedTimerState(timer, elapsedMs, now) {
  if (!Number.isFinite(timer.startedAt) || timer.startedAt <= 0
    || !Number.isFinite(elapsedMs) || elapsedMs < 0 || !Number.isInteger(elapsedMs)) return null;
  const end = timer.stoppedAt === undefined ? now : timer.stoppedAt;
  if (!Number.isFinite(end) || end <= 0 || end - elapsedMs <= 0) return null;
  return { ...timer, startedAt: end - elapsedMs, baseTime: 0 };
}

export function timerAdjustmentError(nextTimer, participants, info) {
  if (!nextTimer) return 'Iniciá el cronómetro y elegí un tiempo válido.';
  const pedestrian = info.competition === Pedestrismo || info.competition === PedestrismoBackup;
  const categories = Array.isArray(info.categoryStartOffsets) ? info.categoryStartOffsets : [];
  const invalidArrival = participants.some(participant => {
    const arrival = Number(participant.registeredTime1) || 0;
    if (arrival <= 0 || Number(participant.dns) || Number(participant.dnf)
      || Number(participant.disqualified)) return false;
    const category = categories.find(item => String(item.catCod || '').trim()
      === String(participant.catCod || '').trim());
    // Pedestrian arrivals already include the distance offset.
    const offset = pedestrian ? 0 : (category ? Number(category.offset) || 0 : 0) * 60000;
    return arrival - offset < nextTimer.startedAt;
  });
  return invalidArrival ? 'El tiempo elegido dejaría llegadas anteriores a la largada. Elegí un tiempo mayor.' : '';
}



// WEBPACK FOOTER //
// ./src/utils/timer-adjustment.js